import { Component, ViewChild } from '@angular/core';
import { NavbarStatus, NavigationItem, NavigationService } from '../../core/navigation.service';
import { COLOR_PRIMARY_CONTRAST_500, LOCAL_NAVBAR_STATUS_KEY } from '../../shared/constants/operationals';
import { NavigationItemLabel } from '../../shared/constants/translations';
import { UtilsService } from '../../core/utils.service';
import { Meta } from '@angular/platform-browser';
import { DialogService } from '../../core/dialog.service';
import { UnpaidDataComponent } from '../unpaid-data/unpaid-data.component';
import { UnpaidSummaryComponent } from '../unpaid-summary/unpaid-summary.component';
import { ListUnpaidParams } from '../../core/unpaid.service';
import { UnpaidFilterDialogComponent } from '../unpaid-filter-dialog/unpaid-filter-dialog.component';
import { UnpaidFiltersComponent } from '../unpaid-filters/unpaid-filters.component';

@Component({
  selector: 'app-unpaid',
  templateUrl: './unpaid.component.html',
  styleUrls: ['./unpaid.component.scss'],
})
export class UnpaidComponent {
  @ViewChild(UnpaidSummaryComponent) summary_component?: UnpaidSummaryComponent;
  @ViewChild(UnpaidDataComponent) data_component?: UnpaidDataComponent;
  @ViewChild(UnpaidFiltersComponent) filters_component?: UnpaidFiltersComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.unpaid);
  filters?: ListUnpaidParams;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private meta: Meta,
    private dialog_service: DialogService,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
  }

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }

  onRefresh(): void {
    if (this.filters) {
      this.onFilterClear(this.filters);
    } else {
      this.onFilterClear({});
    }
    this.summary_component?.onRefresh();
  }

  onFilter(): void {
    this.dialog_service
      .openDialog(UnpaidFilterDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.params) {
          this.filters = dialog_result.params;
          this.setDataFilters();
        }
      });
  }

  onFilterClear(filters: ListUnpaidParams): void {
    this.filters = filters;
    this.setDataFilters();
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  setDataFilters(): void {
    if (this.areFiltersSet()) {
      this.data_component?.onFilter(this.filters);
    }

    if (!this.areFiltersSet()) {
      this.data_component?.onFilter();
    }
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }

  areFiltersSet(): boolean {
    if (this.filters) {
      const active_filters = Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
      return !!(active_filters && active_filters.length);
    }
    return false;
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterUnpaidKeySet(this.filters, key);
  }
}
